import * as React from 'react';
import { MapContext } from '../Map';

const { useContext, useEffect, useState } = React;

export interface GeocoderProps {
  address?: string;
  location?: any[];
  isGetLocation?: boolean;
  isGetAddress?: boolean;
  getLocation?: (value: any) => any;
  getAddress?: (value: any) => any;
}

function Geocoder(props: GeocoderProps) {
  const { isGetLocation, isGetAddress, address, location } = props;
  const map = useContext(MapContext);
  const [geocoder, setGeocoder]: [any, any] = useState(null);

  useEffect(() => {
    if (!map) {
      return;
    }

    const { AMap } = window as any;

    if (geocoder) {
      ((map as unknown) as AMap.Map).removeControl(geocoder);
    }

    let geocoderEntity: any = null;
    (map as unknown as AMap.Map).plugin(['AMap.Geocoder'], () => {
      geocoderEntity = new AMap.Geocoder({
        city: '全国',
      });
      setGeocoder(geocoderEntity);
      ((map as unknown) as AMap.Map).addControl(geocoderEntity);
    });

    return () => {
      if (geocoderEntity) {
        ((map as unknown) as AMap.Map).removeControl(geocoderEntity);
      }
    };
  }, [map]);


  useEffect(() => {
    if (!geocoder) {
      return;
    }

    if (address && address.length) {
      geocoder.getLocation(address, (status: any, result: any) => {
        if (status === 'complete' && result.info === 'OK') {
          if (props.getLocation) {
            props.getLocation(result);
          }
        } else {
          if (props.getLocation) {
            props.getLocation(null);
          }
          console.log('根据地址查询位置失败');
        }
      });
    }
  }, [geocoder, address]);

  useEffect(() => {
    if (!geocoder) {
      return;
    }
    if (location && location.length !== 0) {
      geocoder.getAddress(location, (status: any, result: any) => {
        if (status === 'complete' && result.info === 'OK') {
          if (props.getAddress) {
            props.getAddress(result);
          }
        } else {
          if (props.getAddress) {
            props.getAddress(null);
          }
          console.log('根据位置查询地址失败');
        }
      });
    }
  }, [geocoder, location]);

  return null;
}
export default Geocoder;
